import React from "react";
import classes from "./About.module.css"
import AboutImage from "../../../../img/MeetingPage.jpeg"

const About = () => {
    return (
        <div className={classes.about}>
            <div className={classes.contentAbout}>
                <div className={classes.imageAbout}>
                    <img src={AboutImage} alt="О нас" />
                </div>
                <div className={classes.textContentAbout}>
                    <h2>О компании</h2>
                    <h1>Чем мы занимаемся?</h1>
                    <h3>ЭнергоТестСервис является Российским предприятием-производителем современных средств измерения и автоматизации.</h3>
                    <h3>Компания является разработчиком и производителем собственных средств измерения.</h3>
                </div>
            </div>
        </div>
    )
}

export default About